import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import { required, email} from "vuelidate/lib/validators";
import citiesData from "@/assets/json_data/cities.json";
import countiesData from "@/assets/json_data/counties.json";

  // set cities data
  var citiesList = [];
  var keys = Object.keys(citiesData);
  keys.forEach(function (key) {
    citiesList.push(citiesData[key]);
  });
  citiesList.sort();

  // set counties data
  var countiesList = [];
  var keys = Object.keys(countiesData);
  keys.forEach(function (key) {
    countiesList.push(countiesData[key]);
  });
  countiesList.sort();

  export default {
    components: {
    },
    data() {
      return {
        ShowLoader: false,
        Saving: false,
        submitted: false,
        SearchKey: "",
        NewBranch: {
          name: "",
          email: "",
          contact_number: "",
          address: "",
          town: "",
          county: "",
          postcode: "",
          forename: "",
          surname: "",
        },
        Counties: countiesList,
        Cities: citiesList,
      };
    },
    validations: {
      NewBranch: {
        name: { required },
        /* email: { required, email },
        contact_number: {required },
        address: {required },
        town: {required },
        county: {required}, 
        postcode: {required},*/
      },
    },
    mounted() {
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions.Branches || !AccountPermissions.Branches.enable|| !AccountPermissions.Branches.add)
      ) {
        this.$router.push("/");
      }
      document.title = pbx_SiteTitle + " - Branch Add";
    },

    methods: {
      CreateBranch() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.Saving = true;
        Axios.post(Endpoints.Branch.Create, {
          token: localStorage.getItem("token"),
          ...this.NewBranch,
        }).then((Response) => {
          this.Saving = false;
          if (Response?.data?.success) {
            this.$swal
              .fire("Branch Added Successfully", "", "success")
              .then(() => {
                this.$router.push("/branches");
              });
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response?.data?.message || "Something went wrong",
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },
    },
  };